export const inputClass =
  'w-full rounded-xl border border-black/10 bg-wash px-3 py-2.5 text-[14px] text-ink outline-none transition-colors focus:border-accent/60';

export const MAX_TITLE = 120;
export const MAX_BODY = 500;

export type DestKind =
  | 'none'
  | 'home'
  | 'football'
  | 'leagues'
  | 'leagues_new'
  | 'pro'
  | 'league'
  | 'miniLeague'
  | 'custom';

export const DEST_OPTIONS: { value: DestKind; label: string }[] = [
  { value: 'none', label: 'No link (just a message)' },
  { value: 'home', label: 'Home · choose a sport' },
  { value: 'football', label: 'Football leagues lobby' },
  { value: 'leagues', label: 'Mini leagues hub' },
  { value: 'leagues_new', label: 'Create a mini league' },
  { value: 'pro', label: 'Go Pro' },
  { value: 'league', label: 'A specific sport league…' },
  { value: 'miniLeague', label: 'A specific mini league…' },
  { value: 'custom', label: 'Custom path…' }
];
